import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent {
  public emailid: string;
  public password: string;
  public error: string;
  public currentuser :any = {};
	constructor(private auth: AuthService, private router: Router,
		private spinnerService: Ng4LoadingSpinnerService) { }
ngOnInit() {
	this.auth.logout();
}
  public submit() {
		this.spinnerService.show();
    this.auth.login(this.emailid, this.password)
      .pipe(first())
      .subscribe(
        result => 
		{	
			this.currentuser = JSON.parse(localStorage.getItem('currentuser'))
			if(this.currentuser.userroleid ==5  )	
			{
				this.router.navigate(['po-list']);
			}
			else if(this.currentuser.userroleid ==4  )	
			{
				this.router.navigate(['po-list']);
			}
			else if(this.currentuser.userroleid ==3  )	
			{
				this.router.navigate(['finance-team-dashboard']);
			}
			else if(this.currentuser.userroleid ==2 )	
			{
				this.router.navigate(['po-approver-dashboard']);
			}
			else if(this.currentuser.userroleid ==6 )	
			{
				this.router.navigate(['review-list']);
			}
			else
			{
				this.router.navigate(['dashboard']);
			}
			this.spinnerService.hide();
		},
        err => this.error = 'Invalid EmailID or Password.'
      );
  }
}